module.exports = __webpack_public_path__ + "img/CSS3.05894dc3.svg";